import { CAMPAIGNS_API_URL } from 'constants/ApiConstants';
import * as types from 'modules/campaigns/actionTypes';

export const isInitialized = (meta = {}) => ({
  type: types.DETAILS_INITIALIZED,
  meta,
});

export const openContentModal = (meta = {}) => ({
  type: types.OPEN_CONTENT_MODAL,
  meta,
});

export const closeContentModal = (meta = {}) => ({
  type: types.CLOSE_CONTENT_MODAL,
  meta
});

export const fetchCampaignPreviewUrl = (campaignId, meta = {}) => ({
  type: types.FETCH_CAMPAIGN_PREVIEW,
  payload: {
    request: {
      method: 'GET',
      url: `${CAMPAIGNS_API_URL}/${campaignId}/preview`,
    },
  },
  meta: {
    '@app-request': true,
    ...meta,
  },
});

export const followCampaign = (campaignId, meta = {}) => ({
  type: types.FOLLOW_CAMPAIGN,
  payload: {
    request: {
      method: 'POST',
      url: `${CAMPAIGNS_API_URL}/${campaignId}/campaignFiles/follow`,
    },
    campaignId,
  },
  meta,
});

export const followCampaignSuccess = (campaignId, meta = {}) => ({
  type: types.FOLLOW_CAMPAIGN_SUCCESS,
  payload: campaignId,
  meta,
});

export const unfollowCampaign = (campaignId, meta = {}) => ({
  type: types.UNFOLLOW_CAMPAIGN,
  payload: {
    request: {
      method: 'POST',
      url: `${CAMPAIGNS_API_URL}/${campaignId}/campaignFiles/unfollow`,
    },
    campaignId,
  },
  meta,
});

export const unfollowCampaignSuccess = (campaignId, meta = {}) => ({
  type: types.UNFOLLOW_CAMPAIGN_SUCCESS,
  payload: campaignId,
  meta,
});
